import banner1 from '../images/banners/Slideshow.jpg';
import banner2 from '../images/banners/SlideshowCryptoForCash.png';
import banner3 from '../images/banners/TallyApp.jpg';
import banner4 from '../images/banners/tallycard.png';
import banner5 from '../images/banners/TallyRaffle.jpg';

export const bannerData = [
    {
        id: 1,
        image: banner1,
        url: 'https://app.tally-ho.org/lottery',
    },
    {
        id: 2,
        image: banner2,
        url: 'https://app.tally-ho.org/pools/stake_tokens',
    },
    {
        id: 3,
        image: banner3,
        url: 'https://exchange.tally.org/',
    },
    {
        id: 4,
        image: banner4,
        url: 'https://exchange.tally.org/',
    },
    {
        id: 5,
        image: banner5,
        url: 'https://exchange.tally.org/',
    }
]